import { render, staticRenderFns } from "./TraxTrainingCompetencyIndexCrudForm.vue?vue&type=template&id=498d4444"
import script from "./TraxTrainingCompetencyIndexCrudForm.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCompetencyIndexCrudForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports